<template>
   <div class="ks_top">
        <div class="ks_ix lf">
          <div class="ix_more rf">
            <img :src='pic'>
            <span>{{username}}</span>
          </div>
        </div>
        <a class="rf backhome">
          <img src="/static/img/back.png"><span>
            <router-link :to="{ name:'userindex'}">
                返回前台
            </router-link></span>
        </a>
    </div>
</template>
<script>
    export default{
        name:'comtop', 
        data () {
        return {
            userid: localStorage.getItem('id'),
            username: localStorage.getItem('username'),
            partadmin: localStorage.getItem('partadmin'),
            pic:localStorage.getItem('pic'),
          }
      },
      mounted(){
        if(this.partadmin==0){
          this.$router.push({ path:'/userindex'})
        }
      }
    }
</script>


// WEBPACK FOOTER //
// src/components/Common/comtop.vue